<template>
  <div>
    <h1 class="text-4xl font-bold uppercase text-green-900">Peristock</h1>
    <h3 class="font-semibold text-gray-500">Termes du service</h3>
    <br />
    <p>
      <span class="font-semibold text-green-900">Politique de confidentialité et Données personnelles :</span>
      <br />
      Aucune données personnelle n'est utilisée pour utiliser Peristock. La création d'un
      compte au sein de l'application sur la base de votre adresse e-mail n'est
      utilisé que par vous, afin de récupérer les données de votre stock, le
      statut de votre offre et réinitialiser votre mot de passe en cas de
      besoin. Votre e-mail ne sera pas utilisé à des fins de démarchage ou
      marketing.
      <br />
      <br />
      Google Analytics / Crashlytics sont des services utilisés par
      l'application afin de collecter des données propres à votre appareil comme
      son modèle, la version du système et sa localisation géographique
      (uniquement le pays) et ce à des fins purement statistiques et pour le débogage de l'application.
    </p>
    <br />
    <span class="font-semibold text-green-900">Politique de Confidentialité pour l'Utilisation du SDK AdMob :</span>
    <br />
    Nous vous informons que Peristock utilise le service de publicité AdMob fourni par Google LLC afin d'améliorer votre
    expérience utilisateur en proposant des annonces pertinentes. Cette politique de confidentialité vise à vous informer
    sur la manière dont nous traitons vos données lorsque vous utilisez notre application.
    <br />
    <br />
    <span class="font-semibold text-green-900">Collecte d'Informations :</span>
    <br />
    AdMob collecte des informations anonymes sur votre appareil, telles que l'identifiant de votre appareil mobile, le
    type de navigateur, l'adresse IP, et les informations sur votre utilisation de l'application. Ces données sont
    utilisées à des fins publicitaires, telles que la personnalisation des annonces en fonction de vos préférences.
    <br />
    <br />
    <span class="font-semibold text-green-900">Utilisation des Cookies :</span>
    <br />
    AdMob utilise des cookies pour collecter des informations et améliorer la pertinence des annonces. Les cookies sont de
    petits fichiers texte stockés sur votre appareil qui nous aident à analyser votre utilisation de l'application.
    <br />
    <br />
    <span class="font-semibold text-green-900">Partage d'Informations :</span>
    <br />
    Les données collectées par AdMob peuvent être partagées avec des partenaires publicitaires pour améliorer la qualité
    des annonces diffusées. Cependant, vos informations personnelles identifiables ne seront jamais partagées sans votre
    consentement explicite.
    <br />
    <br />
    <span class="font-semibold text-green-900">Options de Contrôle :</span>
    <br />
    Vous avez le contrôle sur la collecte de vos données publicitaires. Lors de la première demande d'affichage de
    publicité vous pouvez ajuster vos préférences publicitaires.

    En utilisant Peristock, vous consentez à la collecte et à l'utilisation de vos données par AdMob conformément à cette
    politique de confidentialité.
    <br />
    <br />
    <span class="font-semibold text-green-900">Changements de la Politique de Confidentialité :</span>
    <br />
    Cette politique de confidentialité peut être mise à jour périodiquement pour refléter les changements dans nos
    pratiques de collecte et de traitement des données. Nous vous encourageons à consulter régulièrement cette politique
    pour rester informé.

    Si vous avez des questions ou des préoccupations concernant notre utilisation du SDK AdMob, veuillez nous contacter.
    <br />
    <br />
    Merci d'utiliser Peristock !
    <br />
    <br />
    <a href="https://itunes.apple.com/fr/app/peristock/id1409389244?mt=8" alt="" target="_blank"><img
        src="@/assets/appstore-badge.svg" /></a>
  </div>
</template>

<script>
export default {
  name: "Peristock"
};
</script>

